import script from "./SessionExpiryIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./SessionExpiryIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./SessionExpiryIndicator.vue?vue&type=style&index=0&id=7f484340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f484340"]])

export default __exports__